<template>
  <div class="biz-container" style="padding: 10px;">
    <div class="biz-invest" v-if="bizInfo.bizId === 1">
      <div class="biz-title" >{{bizInfo.title}}</div>
      <div style="margin-left: 20px;font-size:18px;">{{bizInfo.descInfo}}</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="biz-form" style="margin-top: 15px;padding: 10px;">
        <el-form-item label="您的称呼" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入称呼,已加密,请放心填写"></el-input>
        </el-form-item>
        <el-form-item label="您的电话" prop="phone">
          <el-input v-model="ruleForm.phone" @input="phoneInput" placeholder="请输入手机号,已加密,请放心填写"></el-input>
        </el-form-item>
        <el-form-item label="加盟城市" prop="region" >
          <div style="display: flex;">
            <el-select v-model="ruleForm.province"  placeholder="省" @change="changePro"
                       popper-class="popper-scrollbar-show">
<!--              <el-option key="" label="-请选择-" value="" ></el-option>-->
              <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="margin-left:10px;">
              </el-option>
            </el-select>
            <el-select v-model="ruleForm.city" placeholder="市" @change="changeCity"
                       popper-class="popper-scrollbar-show">
              <el-option key="" label="-请选择-" value="" ></el-option>
              <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="margin-left:10px;">
              </el-option>
            </el-select>
            <el-select v-model="ruleForm.area" placeholder="区/县"
                       popper-class="popper-scrollbar-show">
              <el-option key="" label="-请选择-" value="" ></el-option>
              <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="margin-left:10px;">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="加盟意向" prop="resource">
          <div class="invest-intend">
            <el-radio-group v-model="ruleForm.resource">
              <el-radio label="1">近期开店</el-radio>
              <el-radio label="2">了解咨询</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label="投资规模" prop="type">
          <div class="invest-range">
            <el-radio-group v-model="ruleForm.type">
              <el-radio label="1">0-10万</el-radio>
              <el-radio label="2">10-30万</el-radio>
              <el-radio label="3">30-50万</el-radio>
              <el-radio label="4">50-100万</el-radio>
              <el-radio label="5">100-300万</el-radio>
              <el-radio label="6">300万以上</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
      </el-form>


      <div class="confirm-info" >
        <el-checkbox v-model="checkConfirmShare" label=""></el-checkbox>
        <!--<span class="confirm-info-before-text" style="margin-left: .05rem;color:red;font-weight: bold;width:90%;">我司将根据您所填的用户信息内容，向百度及百度的优质合作方分发(勾选即同意)</span>-->
        <span class="confirm-info-before-text" style="margin-left: .05rem;color:red;font-weight: bold;width:90%;">允许推荐给更多优质服务商为您提供服务(勾选即同意)</span>

        <!--        <router-link to="/userAgreeForBiz" custom v-slot="{ navigate }">-->
        <!--          <span @click="navigate"  role="link" style="color:blue;">《个人信息授权与隐私政策》</span>-->
        <!--        </router-link>-->
      </div>

      <div class="confirm-info" >
        <el-checkbox v-model="checkConfirm" label=""></el-checkbox>
        <span class="confirm-info-before-text" style="margin-left: .05rem;">阅读并同意</span>
        <div @click="openUserAgree">
          <span  role="link" style="color:blue;">《个人信息授权》</span>
        </div>
        <div>
          <span>与</span>
        </div>
        <div @click="openUserPrivacy">
          <span  role="link" style="color:blue;">《隐私政策》</span>
        </div>
      </div>


      <!--          <el-button type="primary" >立即提交获取加盟详情</el-button>-->
      <div :style="checkConfirm  && checkConfirmShare ?'background-color:#f04141':''" class="submit-button" @click="submitForm('ruleForm')" style="width: 80%">
            立即提交获取加盟详情
      </div>

      <div class="confirm-info" >
        <div class="confirm-info-before-text" style="margin-left: .05rem;color:black;font-size: 14px;">
          <span style="color: red;font-weight: bold">*</span>风险提示：投资有风险，请谨慎选择；
        </div>
        <!--        <router-link to="/userAgreeForBiz" custom v-slot="{ navigate }">-->
        <!--          <span @click="navigate"  role="link" style="color:blue;">《个人信息授权与隐私政策》</span>-->
        <!--        </router-link>-->
      </div>

    </div>

    <div class="biz-beauty" v-if="bizInfo.bizId === 2">
      <div style="margin-left: 20px;margin-top: 20px;font-size:22px;font-weight: bolder;">{{bizInfo.title}}</div>
<!--      <div style="margin-left: 20px;font-size:18px;">{{bizInfo.descInfo}}</div>-->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="biz-form" style="margin-top: 15px;padding: 10px;">
        <el-form-item label="您的称呼" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入您的称呼"></el-input>
        </el-form-item>
        <el-form-item label="您的电话" prop="phone">
          <el-input v-model="ruleForm.phone" @input="phoneInput" placeholder="请输入您的联系方式"></el-input>
        </el-form-item>
        <el-form-item label="所在地域" prop="region2" >
          <div style="display: flex;">
            <el-select v-model="ruleForm.province"  placeholder="省" @change="changePro"
                       popper-class="popper-scrollbar-show">
              <!--              <el-option key="" label="-请选择-" value="" ></el-option>-->
              <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="margin-left:10px;">
              </el-option>
            </el-select>
            <el-select v-model="ruleForm.city" placeholder="市" @change="changeCity"
                       popper-class="popper-scrollbar-show">
              <el-option key="" label="-请选择-" value="" ></el-option>
              <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="margin-left:10px;">
              </el-option>
            </el-select>

            <el-select v-model="ruleForm.area" placeholder="区/县"
                       popper-class="popper-scrollbar-show">
              <el-option key="" label="-请选择-" value="" ></el-option>
              <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="margin-left:10px;">
              </el-option>
            </el-select>

<!--            <el-select v-model="ruleForm.area" placeholder="区/县">-->
<!--              <el-option label="区域一" value="shanghai"></el-option>-->
<!--              <el-option label="区域二" value="beijing"></el-option>-->
<!--            </el-select>-->
          </div>
        </el-form-item>
      </el-form>
      <span style="color: #f04141;"></span>

      <div class="confirm-info" >
        <el-checkbox v-model="checkConfirmShare" label=""></el-checkbox>
        <!--<span class="confirm-info-before-text" style="margin-left: .05rem;color:red;font-weight: bold;width:90%;">我司将根据您所填的用户信息内容，向百度及百度的优质合作方分发(勾选即同意)</span>-->
        <span class="confirm-info-before-text" style="margin-left: .05rem;color:red;font-weight: bold;width:90%;">允许推荐给更多优质服务商为您提供服务(勾选即同意)</span>

<!--        <router-link to="/userAgreeForBiz" custom v-slot="{ navigate }">-->
<!--          <span @click="navigate"  role="link" style="color:blue;">《个人信息授权与隐私政策》</span>-->
<!--        </router-link>-->
      </div>

      <div class="confirm-info-new" >
        <div class="confirm-info">
          <el-checkbox v-model="checkConfirm" label=""></el-checkbox>
          <span class="confirm-info-before-text" style="margin-left: .05rem;">自动输入历史信息</span>
        </div>
        <div class="confirm-info" style="margin-left: 20px;">
          <div @click="openUserAgree">
            <span  role="link" style="color:blue;">《个人信息授权》</span>
          </div>
          <div>
            <span>与</span>
          </div>
          <div @click="openUserPrivacy">
            <span  role="link" style="color:blue;">《隐私政策》</span>
          </div>
        </div>
      </div>

      <!--          <el-button type="primary" >立即提交获取加盟详情</el-button>-->
      <div :style="checkConfirm && checkConfirmShare?'background-color:#f04141':''" class="submit-button" @click="submitForm('ruleForm')" style="width: 80%">
        提交
      </div>
      <div class="confirm-info" >
        <div class="confirm-info-before-text" style="margin-left: .05rem;color:black;font-size: 14px;">
          <span style="color: red;font-weight: bold">*</span>风险提示：理性看待医美需求 审慎作出医美决策 医美有风险 整形需谨慎
        </div>
        <!--        <router-link to="/userAgreeForBiz" custom v-slot="{ navigate }">-->
        <!--          <span @click="navigate"  role="link" style="color:blue;">《个人信息授权与隐私政策》</span>-->
        <!--        </router-link>-->
      </div>
    </div>

    <div class="biz-jiaju" v-if="!aiBotDialog && bizInfo.bizId === 1771">
      <div style="margin-left: 20px;margin-top: 20px;font-size:22px;font-weight: bolder;">{{bizInfo.title}}</div>
      <div style="margin-left: 20px;font-size:18px;">{{bizInfo.descInfo}}</div>
      <el-form v-if="selectOption && selectOption.length > 0" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="biz-form" style="margin-top: 15px;">
        <el-form-item  :label="'咨询类别（选填）'" prop="checkList">

          <div style="margin-left: 10px;">已选：{{'('+(ruleForm.checkList?ruleForm.checkList.length:0)+'/'+limitCategoryNum+')'}}</div>
          <!--          <div :style="{height: this.checkHeight,overflow: 'hidden'}" class="check-box-div">-->
          <!--            <el-checkbox-group  :max="bizInfo.limitCategoryNum" v-model="ruleForm.checkList"  @change="handleCheckedCitiesChange">-->
          <!--              <el-checkbox-button  :disabled="categoryDisableNew(item.id)" v-for="item in bizInfo.categoryList" :label="item.id" :key="item.id" @change="chooseBrand(item)">{{item.category}}</el-checkbox-button>-->
          <!--            </el-checkbox-group>-->
          <!--          </div>-->

          <!--          <div class="openCheckButton" @click="openCheckDiv">-->
          <!--            {{!openCheck?'展开':'收起'}}-->
          <!--            <i class="el-icon-caret-bottom" v-if="!openCheck"></i>-->
          <!--            <i class="el-icon-caret-top" v-if="openCheck"></i>-->
          <!--          </div>-->
          <el-cascader
              style="margin-top:10px;"
              v-model="ruleForm.checkList"
              placeholder="选择类目"
              :options="selectOption"
              :props="selectProps"
              :show-all-levels="false"
              collapse-tags
              clearable
              @change="changeSubCategory"></el-cascader>

        </el-form-item>

        <el-form-item label="您的称呼" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入您的称呼"></el-input>
        </el-form-item>

        <el-form-item label="" prop="gender">
          <el-radio v-model="ruleForm.gender" label="1">先生</el-radio>
          <el-radio v-model="ruleForm.gender" label="2">女士</el-radio>
        </el-form-item>
        <el-form-item label="您的电话" prop="phone">
          <el-input v-model="ruleForm.phone" @input="phoneInput" placeholder="请输入您的联系方式"></el-input>
        </el-form-item>
        <el-form-item label="所在地域" prop="region2" >
          <div style="display: flex;">
            <el-select v-model="ruleForm.province"  placeholder="省" @change="changePro"
                       popper-class="popper-scrollbar-show">
              <!--              <el-option key="" label="-请选择-" value="" ></el-option>-->
              <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="margin-left:10px;">
              </el-option>
            </el-select>
            <el-select v-model="ruleForm.city" placeholder="市" @change="changeCity"
                       popper-class="popper-scrollbar-show">
              <el-option key="" label="-请选择-" value="" ></el-option>
              <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="margin-left:10px;">
              </el-option>
            </el-select>

            <el-select v-model="ruleForm.area" placeholder="区/县"
                       popper-class="popper-scrollbar-show">
              <el-option key="" label="-请选择-" value="" ></el-option>
              <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="margin-left:10px;">
              </el-option>
            </el-select>

            <!--            <el-select v-model="ruleForm.area" placeholder="区/县">-->
            <!--              <el-option label="区域一" value="shanghai"></el-option>-->
            <!--              <el-option label="区域二" value="beijing"></el-option>-->
            <!--            </el-select>-->
          </div>
        </el-form-item>

      </el-form>
      <span style="color: #f04141;"></span>

      <div class="confirm-info" >
        <el-checkbox v-model="checkConfirmShare" label=""></el-checkbox>
        <!--        <span class="confirm-info-before-text" style="margin-left: .05rem;color:red;font-weight: bold;width:90%;">我司将根据您所填的用户信息内容，向百度及百度的优质合作方分发(勾选即同意)</span>-->
        <span class="confirm-info-before-text" style="margin-left: .05rem;color:red;font-weight: bold;width:90%;">允许推荐给更多优质服务商为您提供服务(勾选即同意)</span>

        <!--        <router-link to="/userAgreeForBiz" custom v-slot="{ navigate }">-->
        <!--          <span @click="navigate"  role="link" style="color:blue;">《个人信息授权与隐私政策》</span>-->
        <!--        </router-link>-->
      </div>

      <div class="confirm-info">
        <el-checkbox v-model="checkConfirm" label=""></el-checkbox>
        <span class="confirm-info-before-text" style="margin-left: .05rem;">阅读并同意</span>
        <div @click="openUserAgree">
          <span  role="link" style="color:blue;">《个人信息授权》</span>
        </div>
        <div>
          <span>与</span>
        </div>
        <div @click="openUserPrivacy">
          <span  role="link" style="color:blue;">《隐私政策》</span>
        </div>
      </div>
      <!--          <el-button type="primary" >立即提交获取加盟详情</el-button>-->
      <div :style="checkConfirm && checkConfirmShare?'background-color:#f04141':''" class="submit-button" @click="submitForm('ruleForm')" style="width: 80%">
        {{ showAiBot === 1 ? '开始咨询':'提交'}}
      </div>
      <!--            <div :style="checkConfirm && checkConfirmShare?'background-color:#f04141':''" class="submit-button" @click="openAiBot" style="width: 80%">-->
      <!--              开始咨询-->
      <!--            </div>-->
    </div>

    <div class="ai-bot" v-show="aiBotDialog">
      <div id="edu-bot-container"  style="width: 100%;  height: 100vh;">
        <!--      <iframe-->
        <!--          id="edu-bot-iframe"-->
        <!--          src="https://aibqt.baidu.com/edu-bot/form"-->
        <!--          frameborder="0"-->
        <!--          width="100%"-->
        <!--          height="100%">-->
        <!--      </iframe>-->
      </div>
    </div>
  </div>
</template>
<script>
import {monitorBiz,reportBiz} from "../../api/h5Request";

export default {
  name: "InvestBizPage",
  props: {
    bizInfo: {
      type: Object,
      default: {},
      required:true
    }
  },
  data() {
    let validateRegion = (rule, value, callback) => {
      value = this.ruleForm.province + "," + this.ruleForm.city + "," + this.ruleForm.area;
      if (!this.ruleForm.province ||!this.ruleForm.city || !this.ruleForm.area) {
        callback(new Error('请选择具体加盟城市'));
      } else {
        callback();
      }
    };
    let validateRegion2 = (rule, value, callback) => {
      value = this.ruleForm.province + "," + this.ruleForm.city ;
      if (!this.ruleForm.province ||!this.ruleForm.city || !this.ruleForm.area) {
        callback(new Error('请选择所在地域'));
      } else {
        callback();
      }
    };
    return {
      provinces: [], // 省份数据
      cities: [], // 城市数据
      districts: [], // 区数据
      checkConfirm:false,
      checkConfirmShare:false,
      ruleForm: {
        name: '',
        region: '',
        phone: '',
        type: '',
        resource: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入您的称呼', trigger: 'blur' },
          { min: 2, max: 5, message: '请输入长度在 2 到 5 个字符的称呼', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入您的联系方式', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入11位有效手机号码', trigger: 'blur' },
        ],
        region: [
          { validator: validateRegion,required: true, message: '请选择加盟城市', trigger: 'blur' }
        ],
        region2: [
          { validator: validateRegion2,required: true, message: '请选择所在地域', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择预计投资规模', trigger: 'blur' }
        ],
        resource: [
          { required: true, message: '请选择加盟意向', trigger: 'blur' }
        ],
      },
      provinceList:[],
      cityList:[],
      areaList:[],
      aiBotDialog:false,
      limitCategoryNum:5,
      selectOption:[],
      selectProps:{
        multiple: true
      },
      lastValidValues:[],
      subOptionList:[],
      showAiBot:0,
      aiTradeLevel:'',
      categoryId:'',
      subCategoryList:[],
      tradeLevel1:'',
      tradeLevel2:'',
      tradeLevel3:'',//多个id之间用@@分隔，
    };
  },
  methods: {
    openAiBot(){
      if(!this.aiTradeLevel){
        return;
      }
      if(this.aiTradeLevel && this.aiTradeLevel.length > 0){
        this.tradeLevel1 = this.aiTradeLevel.slice(0,4);
        this.tradeLevel2 = this.aiTradeLevel.slice(0,6);
        if(this.aiTradeLevel.length > 6){
          this.tradeLevel3 = this.aiTradeLevel;
        }
      }

      if(this.ruleForm.checkList && this.ruleForm.checkList.length > 0){
        let checkItem3 = new Set();
        this.ruleForm.checkList.forEach(tempItem=>{
          let checkItem = tempItem[tempItem.length - 1]
          let subItem = this.subOptionList.filter(e=>e.value === checkItem)[0];
          if(subItem && subItem.aiTradeLevel && subItem.aiTradeLevel.length > 6){
            checkItem3.add(subItem.aiTradeLevel)
          }
        })
        if(checkItem3.length > 0){
          let tempCheckItems = [];
          checkItem3.forEach(e=>{
            tempCheckItems.push(e)
          })
          this.tradeLevel3 = tempCheckItems.join("@@");
        }
      }
      this.aiBotDialog = true;
      // console.log('tradeLevel',this.tradeLevel1,this.tradeLevel2,this.tradeLevel3)
      this.initAiFrame();
    },
    initAiFrame(){
      const iframe = document.createElement('iframe');
      iframe.src = 'https://aibqt.baidu.com/edu-bot/';
      iframe.id = 'edu-bot-iframe';
      iframe.style.cssText = 'border:0;';
      iframe.frameborder = '0';
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.border = '0';
      // 清空容器（移除所有子元素）
      document.getElementById('edu-bot-container').innerHTML = '';
      // 再添加新的iframe
      document.getElementById('edu-bot-container').appendChild(iframe);
      this.initAiConfig();
    },
    initAiConfig(){
      if(!this.tradeLevel1 || !this.tradeLevel2){
        return;
      }
      if(window.__BOT__CONFIG){
        // window.__BOT__CONFIG.formId = this.formId;
        window.__BOT__CONFIG.tradeLevel1 = this.tradeLevel1;
        window.__BOT__CONFIG.tradeLevel2 = this.tradeLevel2;
        window.__BOT__CONFIG.tradeLevel3 = this.tradeLevel3;
      }else{
        const __BOT__CONFIG = {
          // 必选参数
          a: '4447EF401D9135C935F504C92A',
          s: '71ea0fd2aebe4e6d9d828b812c5dfb15',
          tradeLevel1: this.tradeLevel1,
          tradeLevel2: this.tradeLevel2,
          rfqunionid: '12395848',//媒体标识
          mediumId: '275745601',//网站域名ID
          aid: 'aib0e5126cee',
          account: 'union-p14932',

          // 默认参数
          fromUrl: window.location.href,

          // 选填参数
          taid: '',
          tsid: '',
          pageCategory: '',
          pageTitle: '',
          query: '',
          tradeLevel3List: this.tradeLevel3, // 非必传，业务需要时再传
          autoPlay:0,
          // formId:this.formId,
          nonce: 1,
          componentId: 18,
          version: '1.0',
        };
        window.__BOT__CONFIG = __BOT__CONFIG
        // 前卡曝光统计接入，务必要在__BOT__CONFIG参数后面引入，否则会导致参数传递失败
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://miniapp-ad.bj.bcebos.com/aigc/edu-bot/log.js';
        document.head.appendChild(script);
        console.log('__BOT__CONFIG',__BOT__CONFIG)
      }

      let _this = this;
      // 参数通信接口
      function handleMessage(event) {
        if (event.data && event.data.type === 'init-config') {
          console.log('initConfig')
          event.source.postMessage({ __BOT__CONFIG: window.__BOT__CONFIG }, event.origin);
        }
        if (event.data && event.data.type === 'close-iframe') {
          const eduIframe = document.getElementById('edu-bot-iframe');
          if (eduIframe) { // 加个判断避免找不到元素报错
            eduIframe.style.display = 'none';
            location.reload();
          }
        }
      }

      // 先移除旧的监听器（如果存在），再绑定新的
      window.removeEventListener('message', handleMessage);
      window.addEventListener('message', handleMessage);
    },
    changeSubCategory(){
      let checkNum = this.ruleForm.checkList.length;
      if(checkNum > this.limitCategoryNum){
        // 超过上限时，恢复到上一次的选中状态
        this.$nextTick(() => {
          let tempForm = this.copyForm();
          tempForm.checkList = this.lastValidValues;
          this.ruleForm = tempForm;
        });
        // 提示用户
        this.$toast.center(`最多只能选择 ${this.limitCategoryNum} 项`);
      }else{
        // 记录当前有效状态（用于超出时回滚）
        this.lastValidValues = this.ruleForm.checkList;
      }
    },
    initSelectOption(list){
      this.selectOption = []
      if(!list || list.length === 0){
        return;
      }
      list.forEach(e =>{
        let optionItem = {};
        optionItem.label = e.category;
        optionItem.value = e.id;
        optionItem.aiTradeLevel = e.aiTradeLevel;
        this.subOptionList.push(optionItem);
        if(e.subList && e.subList.length > 0){
          this.setSubList(optionItem,e.subList);
        }
        this.selectOption.push(optionItem);
      })
    },
    setSubList(item,subList){
      let subListItem = [];
      subList.forEach(e=>{
        let optionItem = {};
        optionItem.label = e.category;
        optionItem.value = e.id;
        optionItem.aiTradeLevel = e.aiTradeLevel;
        this.subOptionList.push(optionItem);
        if(e.subList && e.subList.length > 0){
          this.setSubList(optionItem,e.subList);
          subListItem.push(optionItem);
        }
      })
      if(subListItem.length > 0){
        item.children = subListItem;
      }
    },
    openUserAgree(){
      //href="/userAgreeForBiz" target="_blank"
      window.open('/userAgreeForBiz', '_blank');
    },
    openUserPrivacy(){
      //href="/userAgreeForBiz" target="_blank"
      window.open('/privacyForBiz', '_blank');
    },
    phoneInput(event){
      // 仅允许输入数字
      this.ruleForm.phone = this.ruleForm.phone.replace(/\D/g, '');
    },
    getProvince(){
      this.provinceList =  this.$city.getProvince();
    },
    changePro(){
      let pid = this.ruleForm.province;
      this.cityList =  this.$city.getCityList(pid);
      let tempForm = this.copyForm();
      tempForm.city = '';
      tempForm.area = '';
      this.ruleForm = tempForm;
    },
    changeCity(){
      let pid = this.ruleForm.province;
      let cid = this.ruleForm.city;
      this.areaList =  this.$city.getAreaList(pid,cid);
      let tempForm = this.copyForm();
      tempForm.area = '';
      this.ruleForm = tempForm;
    },
    copyForm(){
      let tempForm = {};
      tempForm.name = this.ruleForm.name;
      tempForm.region = this.ruleForm.region;
      tempForm.province = this.ruleForm.province;
      tempForm.city = this.ruleForm.city;
      tempForm.area = this.ruleForm.area;
      tempForm.phone = this.ruleForm.phone;
      tempForm.type = this.ruleForm.type;
      tempForm.resource = this.ruleForm.resource;
      tempForm.checkList= this.ruleForm.checkList;
      tempForm.gender = this.ruleForm.gender;
      return tempForm;
    },
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.checkConfirm || !this.checkConfirmShare){
            this.$toast.center('请查看并同意相关协议后提交');
            return;
          }
          this.$confirm('确认提交信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'l_c_yes',
            cancelButtonClass: 'l_c_no',
            type: 'warning'
          }).then(() => {
            this.bizReport();

          }).catch(() => {

          });
        } else {
          this.$toast.center('请将信息补充完整');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    bizMonitor(bizInfo){
      let params = {};
      params.uuid = this.common.getUUID();
      params.userId = this.userTool.getUserId();
      params.noteId = bizInfo.noteId;
      params.categoryId = bizInfo.categoryId;
      params.pageId = bizInfo.pageId;
      params.bizType = bizInfo.bizId;
      let finalParams = this.common.encodeBizParams(params);
      monitorBiz(finalParams).then((response) => {
        // console.log(response);
      }).catch((e) => {
        console.log(e)
      })
      if(bizInfo.showAiBot === 1){
        this.limitCategoryNum = 5;
        this.showAiBot = 1;
        this.aiTradeLevel = bizInfo.aiTradeLevel;
        if(bizInfo.subCategoryList && bizInfo.subCategoryList.length > 0){
          this.initSelectOption(bizInfo.subCategoryList);
        }
      }else{
        this.showAiBot = 0;
      }
    },
    bizReport(){
      let params = {};
      params.uuid = this.common.getUUID();
      params.userId = this.userTool.getUserId();
      params.noteId = this.bizInfo.noteId;
      params.categoryId = this.bizInfo.categoryId;
      params.pageId = this.bizInfo.pageId;
      params.bizType = this.bizInfo.bizId;
      params.nickName = this.ruleForm.name;
      params.phone = this.ruleForm.phone;
      if(this.ruleForm.checkList && this.ruleForm.checkList.length > 0){
        params.categories = this.ruleForm.checkList.filter(e => e && e.length > 0).map(e=>{
          return e[e.length - 1]
        });
      }

      if(this.showAiBot === 1){
        params.fromAi = 1;
      }else{
        params.fromAi = 0;
      }
      let provinceInfo = this.$city.getProvinceInfo(this.ruleForm.province);
      if(provinceInfo){
        params.province = provinceInfo.name;
        params.provinceCode = provinceInfo.areaCode;
        let cityInfo = this.$city.getCityInfo(provinceInfo,this.ruleForm.city);
        if(cityInfo){
          params.city = cityInfo.name;
          params.cityCode = cityInfo.areaCode;
          let areaInfo = this.$city.getAreaInfo(cityInfo,this.ruleForm.area);
          if(areaInfo){
            params.area = areaInfo.name;
            params.areaCode = areaInfo.areaCode;
          }
        }
      }
//    private BizCityVo region;
      params.gender = this.ruleForm.gender;
      params.intent = this.ruleForm.resource;// 1:近期开店 2：了解咨询
      params.scale = this.ruleForm.type;// 1:0-10万 2：10-30万 3：30-50万 4：50-100万 5：100-300万 6：300万以上
      let finalParams = this.common.encodeBizParams(params);
      reportBiz(finalParams).then((response) => {
        // console.log(response);
        if(response.status === 1){
          // this.$message.success("提交成功！");
          if(this.showAiBot === 1){
            this.openAiBot();
          }else{
            this.$toast.center('提交成功！');
            this.ruleForm = {
              name: '',
              region: '',
              phone: '',
              type: '',
              resource: '',
            };
            this.checkConfirmShare = false;
            this.checkConfirm = false;
          }

        }else{
          // this.$message.error("");
          this.$toast.center('提交失败！请稍候再试～');
        }
      }).catch((e) => {
        console.log(e)
      })
    }
  },
  created:function (){
  },
  mounted:function (){
    this.getProvince();
  },
  watch: {

  },
};
</script>
<style scoped>
.invest-range .el-radio{
  width: 30%;
  margin-top: 10px;
  margin-left: 10px;
}
.submit-button{
  width: 1.6rem;
  height: .32rem;
  text-align: center;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: .32rem;
  color: #fff;
  background: #ee7979;
  border-radius:.04rem;
  font-size: .13rem
}
.biz-invest{
  background-color: #f5f4f4;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 15px;
}

.biz-beauty{
  background-color: #f5f4f4;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  border-radius: 15px;
}

.biz-jiaju{
  background-color: #f5f4f4;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  border-radius: 15px;
}


.biz-title{
  margin-left: 20px;
  margin-top: 20px;
  font-size:22px;
  font-weight: bolder;
}
.confirm-info{
  display: flex;
  justify-content:flex-start;
  margin-top:10px;
  width: 100%;
  font-size: .13rem;
  margin-left: 10px;
  align-items: center
}

.confirm-info-new{
  display: flex;
  justify-content:flex-start;
  margin-top:10px;
  width: 100%;
  font-size: .13rem;
  /*margin-left: 10px;*/
  align-items: center;
  flex-wrap: wrap;
}

.popper-scrollbar-show .el-scrollbar .el-scrollbar__bar.is-vertical {
  display: block !important;
}

</style>



// WEBPACK FOOTER //
// src/components/bizPage/BizPage.vue